import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import {
  ListWidgetComponent,
  ImageWidgetComponent,
  CalendarWidget,
  transformImageWidget,
  IconComponent,
} from '@outlaw/community';

@Component({
  selector: 'app-calendar-events-widget',
  imports: [ListWidgetComponent, ImageWidgetComponent, IconComponent],
  templateUrl: './calendar-events-widget.component.html',
  styleUrls: ['./calendar-events-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarEventsWidgetComponent {
  widget = input<CalendarWidget | undefined>(undefined);
  limit = input<number>(0);
  headerLink = input<string>('');

  title = computed(() => this.widget()?.title || '');
  events = computed(() => this.widget()?.events || []);

  processedEvents = computed(() => {
    const events = this.events().map((widget) => transformImageWidget(widget));
    const limit = this.limit();
    return limit > 0 ? events.slice(0, limit) : events;
  });
}
